import { useMatchMedia } from "@/hooks/useMatchMedia";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";

/**
 * True when pointer-driven effects (custom cursor, magnetic pull, card tilt) should run:
 * a mouse or trackpad is present and the user has not asked for reduced motion.
 */
export function useFinePointerMotion(): boolean {
    const finePointer = useMatchMedia("(hover: hover) and (pointer: fine)");
    const reducedMotion = usePrefersReducedMotion();
    return finePointer && !reducedMotion;
}
